import { FC, memo } from 'react';

import { IconBaseProps } from 'icons/IconBase';

export const IconLanguageMark: FC<IconBaseProps> = memo(
  ({ size = 24, ...rest }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle
        cx="12"
        cy="12"
        r="11.2"
        stroke="white"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M16.45 12C16.45 15.2301 15.8756 18.1161 14.9794 20.1646C14.5307 21.1901 14.0172 21.9697 13.4875 22.4818C12.9616 22.9902 12.4602 23.2 12 23.2C11.5398 23.2 11.0384 22.9902 10.5125 22.4818C9.98282 21.9697 9.46926 21.1901 9.02062 20.1646C8.12437 18.1161 7.55 15.2301 7.55 12C7.55 8.76994 8.12437 5.88393 9.02062 3.83537C9.46926 2.80991 9.98282 2.03027 10.5125 1.51818C11.0384 1.00981 11.5398 0.8 12 0.8C12.4602 0.8 12.9616 1.00981 13.4875 1.51818C14.0172 2.03027 14.5307 2.80991 14.9794 3.83537C15.8756 5.88393 16.45 8.76994 16.45 12Z"
        stroke="white"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M18.75 3C17.0426 4.84991 14.6494 6 12 6C9.35058 6 6.9574 4.84991 5.25 3"
        stroke="white"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 21C6.9574 19.1501 9.35058 18 12 18C14.6494 18 17.0426 19.1501 18.75 21"
        stroke="white"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M23.25 12L0.75 12"
        stroke="white"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </svg>
  ),
);
